
const nodejs = `<template>
<div></div>
</template>

<script>
import zlib from 'zlib'
export default {
data() {
  return {
    path: "HHOOSSTT", // replace a correct url you need in here 
    socket: "",
    txt: "",
    CHANNEL: { "id": "test", "reqType": "sub", "dataType": "BTC-USDT@depth" }, //  this is just a demo channel, replace your topic you need in here 
    receivedMessage: ""
  }
},
mounted() {
  this.init()
},
methods: {
  init: function () {
    if (typeof (WebSocket) === "undefined") {
      alert("browser not support websocket!")
    } else {
      this.socket = new WebSocket(this.path)
      this.socket.onopen = this.onOpen
      this.socket.onerror = this.onError
      this.socket.onmessage = this.onMessage
    //   this.socket.onclose = this.onClose
    }
  },
  onOpen: function () {
    console.log("WebSocket connected")
    this.socket.send(JSON.stringify(this.CHANNEL))
  },
  onError: function () {
    console.log("WebSocket error")
  },
  onMessage: function (msg) {
    const reader = new FileReader()
    reader.readAsArrayBuffer(msg.data)
    reader.onload = () => {  
      const buf = Buffer.from(reader.result); 
      const msg = Buffer.from(zlib.gunzipSync(buf), 'binary').toString('utf-8')
      console.log(msg)
      if (msg == "Ping") {
        this.socket.send('Pong')
        console.log('Pong')
      }
      this.receivedMessage = msg
    }
  },
//   onclose: function () {
//     console.log("WebSocket closed")
//   }
},
destroyed() {
  this.socket.onclose = this.close
}
}
</script>`
export default nodejs



// WEBPACK FOOTER //
// ./src/utils/codeWs/html.js